import TextWinds from '../../../components/common/TextWinds';
import {
  ClassBookItem,
  LastTeachingBookItem,
} from '../../../constants/types/lms/take-class/type';
import BookListCard from './BookListCard';

interface BookListPanelProps {
  lastTeachingBook: LastTeachingBookItem;
  bookList: ClassBookItem[];
  onBookClick: (bookCode: string) => void;
}

/**
 * 개편 LMS (교사) - 수업하기 페이지 > 북 목록 판넬
 */
const BookListPanel = ({
  lastTeachingBook,
  bookList,
  onBookClick,
}: BookListPanelProps) => {
  const recentBook = bookList.find(
    (book) => book.bookCode === lastTeachingBook?.bookCode,
  );

  return (
    <section className="rounded-xl bg-white px-3 pt-6 shadow-card xl:px-8">
      {recentBook && (
        <section className="border-b border-gray2 pb-6">
          <div className="mb-4 flex items-center justify-between">
            <TextWinds type="title_h3" color="gray9">
              최근 열람
            </TextWinds>
          </div>

          <div className="grid grid-cols-3 gap-x-[15px] gap-y-[23px] xl:grid-cols-8 xl:gap-x-6 xl:gap-y-6">
            <BookListCard
              book={recentBook}
              lastTeachingBook={lastTeachingBook}
              onBookClick={onBookClick}
            />
          </div>
        </section>
      )}

      <section className={recentBook ? 'pt-6' : 'pb-6'}>
        <div className="mb-4 flex items-center justify-between">
          <TextWinds type="title_h3" color="gray9">
            전체 교재
          </TextWinds>

          <TextWinds type="caption1" color="gray7">
            총 {bookList.length}권
          </TextWinds>
        </div>

        {bookList.length > 0 ? (
          <div className="grid h-auto grid-cols-3 gap-x-[15px] gap-y-[23px] pb-8 xl:grid-cols-8 xl:gap-x-6 xl:gap-y-6">
            {bookList.map((book) => {
              return (
                <BookListCard
                  key={book.bookCode}
                  book={book}
                  lastTeachingBook={lastTeachingBook}
                  onBookClick={onBookClick}
                />
              );
            })}
          </div>
        ) : (
          <div className="flex min-h-[200px] items-center justify-center rounded-xl border border-dashed border-gray3 bg-gray0 px-4 py-10 text-center">
            <TextWinds type="content_body3" color="gray6">
              조회된 교재가 없습니다.
            </TextWinds>
          </div>
        )}
      </section>
    </section>
  );
};

export default BookListPanel;
